/* global $ */
import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { nodeIdPropType, treeAdapterPropTypes } from '../propTypes';
import { finishExpandAnimation } from '../store/actions';
import { nodeChildrenIds, nodeExpandedStatus } from '../store/selectors';
import withNextTreeStoreConnect from '../store/withNextTreeStoreConnect';

import Node from './Node';

@withNextTreeStoreConnect(
  (state, { tree, parentId }) => ({
    childrenIds: nodeChildrenIds(tree)(state, parentId),
    expandedStatus: nodeExpandedStatus(tree)(state, parentId),
  }),
  (dispatch, { adapter, plugins }) => ({
    finishExpandAnimation: (treeId, nodeId, expanded) =>
      dispatch(
        finishExpandAnimation(treeId, nodeId, expanded, { adapter, plugins }),
      ),
  }),
)
export default class Nodes extends React.PureComponent {
  static propTypes = {
    tree: PropTypes.string.isRequired,
    parentId: nodeIdPropType,
    plugins: PropTypes.object.isRequired,
    adapter: treeAdapterPropTypes.isRequired,
    childrenIds: PropTypes.oneOfType([
      PropTypes.arrayOf(nodeIdPropType),
      PropTypes.instanceOf(Promise),
    ]),
    expandedStatus: PropTypes.oneOf([
      true,
      false,
      'progress-in',
      'progress-out',
    ]),
    finishExpandAnimation: PropTypes.func.isRequired,
  };

  static defaultProps = {
    parentId: null,
    expandedStatus: false,
    childrenIds: [],
  };

  componentDidMount() {
    this.mounted = true;
  }

  componentDidUpdate(prevProps) {
    const { expandedStatus } = this.props;
    const { expandedStatus: prevExpandedStatus } = prevProps;

    if (expandedStatus !== prevExpandedStatus) {
      switch (expandedStatus) {
        case 'progress-in':
          return this.animate('hide', 'slideDown', true);
        case 'progress-out':
          return this.animate('show', 'slideUp', false);
        case true:
          return (
            prevExpandedStatus !== 'progress-in' &&
            this.animate('hide', 'slideDown', true)
          );
        default:
          break;
      }
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  mounted = false;

  setListElRef = el => (this.listEl = el);

  animate(jqPrepare, jqAnimation, expanded) {
    const finishAnimation = () => {
      if (this.mounted) {
        const { tree, parentId, finishExpandAnimation } = this.props;
        finishExpandAnimation(tree, parentId, expanded);
      }
    };

    const $el = $(this.listEl);
    const magic = 150;
    $el[jqPrepare]();
    $el[jqAnimation](magic, finishAnimation);
  }

  render() {
    const {
      tree,
      plugins,
      adapter,
      parentId,
      childrenIds,
      expandedStatus,
      handleClear,
    } = this.props;

    const className = classnames('jstree-children', 'jstree-no-icons', {
      'jstree-container-ul': !parentId,
    });

    return (
      <ul ref={this.setListElRef} className={className}>
        {childrenIds &&
          expandedStatus &&
          childrenIds.map(id => (
            <Node
              key={id}
              adapter={adapter}
              handleClear={handleClear}
              id={id}
              plugins={plugins}
              tree={tree}
            />
          ))}
      </ul>
    );
  }
}
